// **** import modules ****
// [pm modules]
import { Klass } from "@pressmedia/webappbase";


// **** process ****
const isIe = (Klass("Console").browser[0] === "ie");

if(isIe && document.getElementById && window.addEventListener) {
	window.addEventListener("hashchange", e => {
		const hashId = location.hash.substring(1);
		if( !(/^[A-z0-9_-]+$/).test(hashId) ) {
			return;
		}
		
		const element = document.getElementById(hashId);
		if(element) {
			if( !(/^(?:a|select|input|button|textarea)$/i).test(element.tagName) ) {
				element.tabIndex = -1;
			}
			
			element.focus();
		}
	}, false);
}
